import React from "react";
import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import classes from "../../styling/components/demo/DemoTemplatePreviewCard.module.css";
import {DemoTemplatePreview} from "../../model/DemoTemplatePreview";

interface Props {
    template: DemoTemplatePreview;
    onClick?: () => void;
    onLearningPageClick?: () => void;
}

export const DemoTemplatePreviewCard: React.FC<Props> = (props) => {
    const {template, onClick, onLearningPageClick} = props;
    const {t} = useTranslation();

    return (
        <div className={classes.templateRow}>
            <div className={classes.topRow}>
                <div className={classes.subjectSection}>
                    {template.subject}
                </div>
            </div>
            <div className={classes.mailMetadata}>
                <div className={classes.metadataItem}>
                    <strong>{t('demoMail.sender', 'Sender')}:</strong> {template.sender}
                </div>
            </div>
            {(onClick || onLearningPageClick) && (
                <div className={classes.actions}>
                    {onClick && (
                        <Button
                            size="small"
                            variant="contained"
                            onClick={onClick}
                            color="look2xBlue"
                        >
                            {t('demoMail.viewMail', 'View Mail')}
                        </Button>
                    )}
                    {onLearningPageClick && (
                        <Button
                            size="small"
                            variant="contained"
                            onClick={onLearningPageClick}
                            color="look2xBlue"
                        >
                            {t('demoMail.viewLearningPage', 'View Learning Page')}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

